/* swatches.js */
function SwatchesConstructor(t, e) {
  var n = this;
  n.show_unavailable_options = e.show_unavailable_options || !1, n.productIsValid = n.show_unavailable_options || t.available, n.product_json = t, n.options_name = "", n.options = "", n.viewDesign = window.viewButtons, n.designOption1 = e.designOption1 || "getButtonHtml", n.designOption2 = e.designOption2 || "getButtonHtml", n.designOption3 = e.designOption3 || "getButtonHtml", n.contentParent = e.contentParent, n.enableHistoryState = Boolean(e.enableHistoryState) || !1, n.callback = e.callback || !1, n.texture_obj = e.externalImagesObject || {}, n.colors_obj = e.externalColors || {}, n.color_with_border = e.colorWithBorder || {}, n.product_handle = e.productHandle || {}, n.selectedByDefault = void 0 === e.selectedByDefault || e.selectedByDefault, n.productIsValid && "Title" != t.options && $(n.contentParent).length ? n.initSwatches() : n.callExternalVariantHandler(n.callback, t.variants[0], n.getJsonObject())
}

function getAllOptions(t, e) {
  for (var n = !0, a = {}, i = 0; i < t.length; i++) {
    n = !!e || Boolean(t[i].available);
    var o = t[i].option1,
      l = t[i].option2,
      r = t[i].option3;
    null != o && n && (null != l ? (a[o] = a[o] || {}, null != r ? (a[o][l] = a[o][l] || {}, a[o][l][r] = !e || Boolean(t[i].available)) : a[o][l] = !e || Boolean(t[i].available)) : a[o] = !e || Boolean(t[i].available))
  }
  var c = !1;
  return $.each(a, function (t, e) {
    if (o = t, "object" == typeof a[t] && "Default Title" != t) {
      var n = a[t];
      $.each(n, function (t, e) {
        l = t, c = !1, "object" == typeof n[t] && ($.each(n[t], function (t, e) {
          c || (c = c || e)
        }), a[o][l + "_|av"] = c)
      }), c = !1, $.each(n, function (t, e) {
        var a = e;
        (hasOwnProperty.call(n, t + "_|av") || t.indexOf("_|av") > -1) && (a = t.indexOf("_|av") > -1 && n[t]), c || (c = c || a)
      }), a[o + "_|av"] = c
    }
  }), a
}

function getCurrentOptionsArray(t) {
  var e = t.option1 + "%%" + t.option2 + "%%" + t.option3;
  return e.replace(/\%\%null/g, "").split("%%")
}

function getCurrentVariantById(t, e, n) {
  for (var a = 0; a < t.length; a++) {
    var i = !!n || t[a].available;
    if (e) {
      if (t[a].id == e) return t[a]
    } else if (i) return t[a]
  }
  return t[0]
}

function getCurrentVariantByTitle(t, e, n) {
  if (!e) return t[0];
  for (var a = !0, i = 0; i < t.length; i++) {
    var o = "%%" + t[i].title,
      l = !!n || t[i].available;
    if (o.indexOf("%%" + e) > -1 && l && !a) return t[i];
    if (t[i].title === e && l && a) return t[i];
    i == t.length - 1 && e.indexOf("/") > -1 && ((e = e.split("/")).pop(), e = e.length > 1 ? e.join("/") : e, i = 0, a = !1)
  }
  return t[0]
}

function getVariantIdUrl() {
  var t = location.search;
  return t.indexOf("variant=") > -1 && (t = t.match(/variant=\d+/g), t = parseInt(t[0].match(/\d+/g))), t
}

function isEmpty(t) {
  return 0 === Object.keys(t).length
}

window.viewButtons = function(t, e) {
  var n = ".tt-wrapper",
    a = (e = e || {}).selectedByDefault,
    i = void 0 === e.avaibility || e.avaibility;
  switch (t) {
    case "getFunctionClickHandler":
      return "buttonHandler";
    case "getGroupElementName":
      return n;
    case "getGroupHtml":
      return '<div class="' + n.replace(/([\.#])/g, "") + '"><div class="tt-title-options">' + e.title + ': <span class="current_option_name"></span></div><ul class="tt-options-swatch options-large">' + e.html + "</ul></div>";
    case "getButtonHtml":
      var o = e.value.trim(),
        l = o.toLowerCase(),
        r = e.c_border.indexOf(o) > -1 ? " border" : "",
        c = e.producthandle;
      l = "," + l + ":", l = e.colors.indexOf(l) > -1 && e.colors.split(l).pop().split(",").shift().trim();
      var s = o in e.texture ? ' data-optionimage="true" style="background-image:url(' + e.texture[o] + ')"' : "";
      c + " " + o in e.texture && (s = ' data-optionimage="true" style="background-image:url(' + e.texture[c + " " + o] + ')"'), "" == s && l && (s = ' style="background:' + l + ';"');
      var u = s.indexOf("data-optionimage") > -1 ? ' class="options-color-image"' : "",
        d = i ? "" : "<span" + u + "></span>",
        p = o.indexOf('"') > -1 ? "'" + o + "'" : '"' + o + '"';
      i = i ? "" : ' data-availability="false"';
      var f = "" != s ? "<li" + i + ">" + d + '<a href="#" class="options-color' + r + '" data-value="' + o + '" data-tooltip="' + o + '" ' + s + "></a></li>" : "<li" + i + '><a href="#" data-value=' + p + ">" + o + "</a></li>";
      return e.value == e.selected && a ? f.replace(/<li/, '<li class="active"') : f;
    case "getSelectGroupHtml":
      return '<div class="' + n.replace(/([\.#])/g, "") + '"><div class="tt-title-options">' + e.title + ': <span class="current_option_name"></span></div><div class="form-default"><div class="form-group"><select class="form-control">' + e.html + "</select></div></div></div>";
    case "getSelectButtonHtml":
      return f = "<option>" + e.value.trim() + "</option>", e.value == e.selected && a ? f.replace(/<option/, "<option selected") : f;
    case "showSelectedParametres":
      return 0 != $(n).find(".active").length && ($(n).find(".active").each(function () {
        var t = $(this).find("[data-value]").data("value");
        $(this).closest(n).find(".current_option_name").text(t)
      }), !1)
  }
}
SwatchesConstructor.prototype.destroy = function () {
  var t = $(this.contentParent);
  t.find("a").unbind(), t.find("select").unbind(), t.empty()
}, SwatchesConstructor.prototype.initSwatches = function (t) {
  var e, n = this,
    a = [];
  t = t, e = n.getJsonObject().options;
  for (var i = 0; i < e.length; i++) a[i] = Object(e[i]).name;
  n.options_name = a, n.options = getAllOptions(n.getJsonObject().variants, n.show_unavailable_options), t || (t = n.enableHistoryState && getVariantIdUrl()), n.createSwatches(t)
}, SwatchesConstructor.prototype.createSwatches = function (t) {
  var e = this,
    n = e.viewDesign;
  if (isEmpty(e.options)) return !1;
  var a = getCurrentVariantById(e.getJsonObject().variants, t, e.show_unavailable_options),
    i = getCurrentOptionsArray(a);
  e.createOptionsView(e.contentParent, e.options, e.options_name, i), e[n("getFunctionClickHandler")](), e.callExternalVariantHandler(e.callback, a, e.getJsonObject()), e.selectedByDefault = !0
}, SwatchesConstructor.prototype.buttonHandler = function () {
  var t = this,
    e = t.viewDesign,
    n = $(t.contentParent),
    a = e("getGroupElementName"),
    i = n.find(a);

  function o(e) {
    if ("a" === e[0].localName) {
      if (e.hasClass("active")) return !1;
      0 == n.find(".active").length && i.each(function () {
        $(this).find("ul").find("li").first().addClass("active")
      }), i.find("a").unbind(), e.closest(a).find(".active").removeClass("active"), e.parent().addClass("active")
    } else e.unbind("focusin");
    var o = "";
    i.each(function () {
      $(this).find(".active").length ? o += $(this).find(".active").find("[data-value]").data("value") + " / " : o += $(this).find("select option:selected").text() + " / "
    }), t.endOfTheClickHandler(o)
  }
  i.find("a").click(function (t) {
    t.preventDefault(), o($(this))
  }), i.find("select").change(function () {
    o($(this))
  }), t.selectedByDefault || i.find("select").focusin(function (t) {
    o($(this))
  })
}, SwatchesConstructor.prototype.endOfTheClickHandler = function (t) {
  var e = this;
  t = t.substring(0, t.length - 3);
  var n = getCurrentVariantByTitle(e.getJsonObject().variants, t, e.show_unavailable_options);
  e.enableHistoryState && history.pushState(null, null, location.pathname + "?variant=" + n.id), e.createSwatches(n.id), $(e.contentParent).closest(".tt-product-single-info").find(".input_variant").val(n.id)
}, SwatchesConstructor.prototype.createOptionsView = function (t, e, n, a) {
  var i = this,
    o = i.viewDesign,
    l = $(t).empty(),
    r = i.texture_obj,
    c = i.colors_obj,
    s = i.color_with_border,
    u = "",
    d = "",
    p = "",
    f = [i.designOption1, i.designOption2, i.designOption3],
    v = i.product_handle,
    h = i.selectedByDefault,
    g = !1;
  $.each(e, function (t, i) {
    if (t == a[0] && "object" == typeof e[t] && "Default Title" != t && -1 == t.indexOf("_|av")) {
      var l = e[t];
      $.each(l, function (t, e) {
        t == a[1] && "object" == typeof l[t] && -1 == t.indexOf("_|av") && $.each(l[t], function (t, e) {
          p += o(f[2], {
            avaibility: e,
            value: t,
            selected: a[2],
            title: n[2],
            texture: r,
            colors: c,
            c_border: s,
            producthandle: v,
            selectedByDefault: h
          })
        }), -1 == t.indexOf("_|av") && (g = "object" == typeof l[t] ? l[t + "_|av"] : e, d += o(f[1], {
          avaibility: g,
          value: t,
          selected: a[1],
          title: n[1],
          texture: r,
          colors: c,
          c_border: s,
          producthandle: v,
          selectedByDefault: h
        }))
      })
    }
    "Default Title" != t && -1 == t.indexOf("_|av") && (g = "object" == typeof e[t] ? e[t + "_|av"] : i, u += o(f[0], {
      avaibility: g,
      value: t,
      selected: a[0],
      title: n[0],
      texture: r,
      colors: c,
      c_border: s,
      producthandle: v,
      selectedByDefault: h
    }))
  });
  for (var b = [n[0], n[1], n[2]], y = [u, d, p], _ = 0; _ < y.length; _++) "" != y[_] && l.append(o(f[_].indexOf("getSelect") > -1 ? "getSelectGroupHtml" : "getGroupHtml", {
    title: b[_],
    html: y[_]
  }));
  o("showSelectedParametres")
}, SwatchesConstructor.prototype.getJsonObject = function () {
  return this.product_json
}, SwatchesConstructor.prototype.callExternalVariantHandler = function (t, e, n) {
  t && "function" == typeof t && t(e, n)
};

window.SwatchesConstructor = SwatchesConstructor
